export const noImage =
  "data:image/svg+xml;base64,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";
import videojs from "video.js";

let isResizing = false;
let percentWidth = 50;
let video_has_left = true;
let slides_has_hiden = true;
const docShadow = {
  getElementById: (selector) => {
    return (
      document.getElementById(selector) ||
      (document.querySelector("emp-player")
        ? document
            .querySelector("emp-player")
            .shadowRoot.getElementById(selector)
        : null)
    );
  },
  querySelector: (selector) => {
    return (
      document.querySelector(selector) ||
      (document.querySelector("emp-player")
        ? document
            .querySelector("emp-player")
            .shadowRoot.querySelector(selector)
        : null)
    );
  },
  querySelectorAll: (selector) => {
    return document.querySelectorAll(selector).length > 0
      ? document.querySelectorAll(selector)
      : document.querySelector("emp-player")
      ? document
          .querySelector("emp-player")
          .shadowRoot.querySelectorAll(selector)
      : null;
  },
  getElementsByClassName: (selector) => {
    return document.getElementsByClassName(selector).length > 0
      ? document.getElementsByClassName(selector)
      : document.querySelector("emp-player")
      ? document
          .querySelector("emp-player")
          .shadowRoot.querySelectorAll(`.${selector}`)
      : null;
  },
  getElementsByTagName: (selector) => {
    return document.getElementsByTagName(selector).length > 0
      ? document.getElementsByTagName(selector)
      : document.querySelector("emp-player")
      ? document
          .querySelector("emp-player")
          .shadowRoot.querySelectorAll(selector)
      : null;
  },
};

let player;
let hasMediaSrc = false;
let changeCurrentTime = false;
window.addEventListener("orientationchange", function (event) {
  if (
    window.innerWidth <= 768 &&
    event.target.screen.orientation.angle === 90
  ) {
    let resizer = document.getElementById("resizer");
    if (resizer) {
      resizer.addEventListener("touchstart", function () {
        resizeSlide(player.id());
      });
    }
  }
});

function toHHMMSS(sec) {
  if (typeof sec === "number") {
    var seconds = Math.floor(sec),
      hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    var minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return hours + ":" + minutes + ":" + seconds;
  } else {
    return sec;
  }
}

function durationToSec(duration) {
  return !isNaN(+duration)
    ? duration
    : duration
        .split(":")
        .reverse()
        .reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
}

function toSeconds(hms) {
  var a = hms.split(":"); // split it at the colons

  // minutes are worth 60 seconds. Hours are worth 60 minutes.
  return +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
}

function updateTime(var_player, slides) {
  player = var_player;
  setCueChapter(player.currentTime());
  setCueSlides(player.currentTime(), slides);
}
export function fixThumbnailHeight() {
  const thumbs = docShadow.querySelectorAll(".vjs-sliders-field");
  const { height } = docShadow
    .querySelector(".flickity-slider .vjs-sliders-field")
    .getBoundingClientRect();
  if (thumbs && thumbs.length > 0) {
    thumbs.forEach((t) => {
      t.style.width = Math.floor(height * (16 / 9)) + "px";
    });
  }
}

function changeSlide(ev) {
  var currentTime = ev.target.getAttribute("data-timecode");
  if (currentTime !== null) {
    if (!isNumeric(currentTime)) currentTime = toSeconds(currentTime);
    player.currentTime(currentTime);
  }
}

function changeChapter(ev) {
  var currentTime = ev.target.getAttribute("data-timecode");
  if (currentTime !== null) {
    if (!isNumeric(currentTime)) currentTime = toSeconds(currentTime);
    player.currentTime(currentTime);
  }
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function setCueChapter(currentTime) {
  var transformY = 0;
  if (
    player.$("#vjs-chapter-container") !== null &&
    player.$("#vjs-chapter-container").children !== null &&
    player.$("#vjs-chapter-container").children.length > 0
  ) {
    var plusX =
      docShadow.getElementById("vjs-chapter-container").offsetHeight -
      docShadow.getElementById("navigation-content").offsetHeight;
    var i, line, begin, end;
    var lines = player.$("#vjs-chapter-container").children;

    for (i = 0; i < lines.length; i++) {
      line = lines[i];
      transformY = transformY + line.offsetHeight + 8;
      begin = line.getAttribute("data-timecode");
      if (i < lines.length - 1) {
        end = lines[i + 1].getAttribute("data-timecode");
      } else {
        end = player.duration() || Infinity;
      }
      if (1 * currentTime >= 1 * begin && 1 * currentTime < 1 * end) {
        if (!line.classList.contains("is-active")) {
          // don't update if it hasn't changed
          line.classList.add("is-active");
          if (plusX) {
            transformY =
              transformY -
              docShadow.getElementById("navigation-content").offsetHeight;
            transformY =
              transformY > 0 ? (transformY > plusX ? plusX : transformY) : 0;
            if (
              docShadow.querySelector(
                ".richMedia-navigation-show .scroll-content"
              )
            )
              docShadow.querySelector(
                ".richMedia-navigation-show .scroll-content"
              ).style.transform =
                "translate3d(0px, -" + transformY + "px, 0px)";
          }
          //currentTime.body.scroll.to(line);
        }
      } else {
        line.classList.remove("is-active");
      }
    }
  }
}
function _pausedVideoSlide(currentThumb, loop) {
  const video = docShadow.getElementById("slide-video");
  let currentTime = player.currentTime();
  let count = Math.floor((currentTime - currentThumb) / video.duration);
  currentThumb = currentThumb + video.duration * count;
  let currentDuration = currentTime - currentThumb;
  if (player.paused()) {
    video.classList.add("vjs-paused");
    video.removeAttribute("loop");
    video.pause();
    changeCurrentTime = false;
    let videoDuration = video.duration;
    if (loop || count === 0) {
      videoDuration = currentDuration;
    }
    video.setAttribute("data-current-time", videoDuration);
    video.currentTime = videoDuration;
  } else {
    if (currentTime >= currentThumb) {
      if (loop) {
        _setVideoSlideLoop(video, loop);
        _setCurrentTimeSlideVideo(currentDuration, video);
      } else {
        if (count === 0) {
          video.play();
          video.classList.remove("vjs-paused");
          _setCurrentTimeSlideVideo(currentDuration, video);
          video.removeAttribute("loop");
        } else {
          changeCurrentTime = false;
        }
      }
    }
  }
}
function _setCurrentTimeSlideVideo(currentDuration, video) {
  if (!changeCurrentTime) {
    video.setAttribute("data-current-time", currentDuration);
    video.currentTime = currentDuration;
    changeCurrentTime = true;
  }
}
function _setVideoSlideLoop(video, loop) {
  video.play();
  video.classList.remove("vjs-paused");
  video.loop = loop;
  video.setAttribute("loop", loop);
}
function setCueSlides(currentTime, slides) {
  const thumbs = docShadow.querySelectorAll(".vjs-sliders-field");
  if (!thumbs || thumbs.length === 0) {
    return;
  }

  let currentThumb;
  let found = false;
  let loop = false;
  var lastThumbIndex = 0;
  var currentThumbIndex = 0;
  thumbs.forEach((t, i) => {
    if (t.classList.contains("is-active")) {
      t.classList.remove("is-active");
      lastThumbIndex = i;
    }
  });

  let i = thumbs.length - 1;
  do {
    const thumb = thumbs[i];
    const thumbTime = +thumb.getAttribute("data-timecode");
    if (thumbTime <= currentTime) {
      currentThumbIndex = i;
      currentThumb = thumb;
      found = true;
    }
    i -= 1;
  } while (i >= 0 && !found);

  if (found) {
    currentThumb.classList.add("is-active");

    if (currentThumbIndex !== lastThumbIndex || i === -1) {
      window.flky.selectCell(currentThumbIndex, false, false);
      if (slides && slides.length > 0) {
        let videoSlide = slides.filter(
          (slide) =>
            slide.timecode ===
              parseInt(currentThumb.getAttribute("data-timecode")) &&
            slide.type === "Video"
        );
        if (videoSlide && videoSlide.length > 0) {
          loop = videoSlide[0].loop;
        }
      }
      if (currentThumbIndex !== 0) {
        hasMediaSrc = false;
      }
      _updateOtherSide(currentThumb, currentThumbIndex, loop);
    }
    _pausedVideoSlide(
      parseInt(currentThumb.getAttribute("data-timecode")),
      loop
    );
  } else {
    hasMediaSrc = false;
    _updateOtherSide();
  }
  updateOverlayButtonsPosition();
}
function _updateOtherSide(media, index) {
  const image = docShadow.getElementById("slide-image");
  const video = docShadow.getElementById("slide-video");
  let type, path;
  if (media) {
    type = media.getAttribute("data-type").toLowerCase();
    path = media.getAttribute("data-path");
    let slideImg = media.querySelector(".vjs-sliders-field-thumb");
    if (slideImg.src === noImage && slideImg.src) {
      media.setAttribute("data-path", noImage);
      image.className = image.className + " error";
      path = noImage;
    } else {
      if (image.className.indexOf("error") > -1)
        image.className = image.className.substr(
          0,
          image.className.indexOf("error")
        );
    }
  } else {
    type = "image";
    const isDarkTheme =
      docShadow.querySelector(".video-js") &&
      docShadow.querySelector(".video-js").classList.contains("skin-dark");
    path =
      "data:image/png;base64,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";
    if (isDarkTheme) {
      path =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAACfCAMAAAAVkjZqAAABxVBMVEX////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////sayP7AAAAl3RSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiMkJSYnKCkqKywtLi8wMTIzNDU2Nzg5Ojs9Pj9AQUJDREVGR0hJSktMTU5QUVJTVFVWV1hZWltcXV5fYGFiY2RlZmdoaWprbG1ub3BxcnN0dXZ3eXp7fH1+f4CBgoOEhYaHiImKi4yNjo+QkZKTlJWWl5iZO6yjSgAABgNJREFUeNrt3etTE1ccxvEnIUAIckcQRUTAGBSwIChgW6qIYqEIBQzK1XBRCAQTBQokBBMTd0nIZdk9f2+5r7lQO9BxOjm/zzvOTN58B5IzzzAbAK99butAR1ePQacFboyqzAC4OdFo02snZ99PjM2vOJ3mbAAuRQ76hVBAyM3QAFV+lR0ANyeatIx2YScYlsK7oXBoKRtmRQpJIcHrdlboNEDlmsoBgJuT/d+Y3za3PvvE3XDk88rac6xHwyBxXKPdsIUiIHHEiWbMRgMgSVhDPhBCLsRgyERWTjZInHSdFrrMdJA4rm07tFotSEIYB1rbW0GShBn1r4FQGApDYSgMhaEwFIbCUJjUVlhYQGHO8sb8CoQQQn7wgkdowaMLHoWhMBSGwlAYCkNhKAyFIbTg0YJHCCG04J0wLU5dyEJfii54D2WRXUA4akvRC15jaKmxsfm8TH1hS6qG2Zu50MsZhaEwFOboPWaxoaHxvGr+iKRqmIey1+eX9qTzkAO+L9GlFA1Tu2zd+GtuZvY8LB/cDttAyu4xlcKqHufTyQYACsNbmJsJYTRpWs2/DDOYqgteYpiyxyNz8wvT/U2Gc4RJlQUvMcyNcS9jfneQsehqVxa+oRu0zlmKcHe1GZfG3lveTRWoYVJNYphukQWmO5d9z+r7P8lszQhV/n4sZkIPG0EFYzJjNRyFGWPR2RpgIXwbyHi0wXZboLrZ3lYLXGrJB4xtzW0m8BNmTBE7gIMwddiXPS0Fm3AmfsJ0yzvNUMPsG1W2r34nTMoueGqYcl/0BWLDZNjYW5wwdrQfevTrFQDVzRo1TCoueGqYYTaviwsDkz9oUt985SNsGdBsM6MaJqUveMXOUDPiw2CcvcIRXf/M2KHxd+0Ans3mcxKmMeIwJIZpjtozcAZOwvzOXuM0zB0cK9n0VXAeZph1qWGaoD+kyVmMmjgPM846cWzJ67A5PjoO2FeFBs7DmNUwH4JO99bOjiiKQf/a17uch+llQzhWshzcfppTVVNdXfbTpq+S8zAt0nImjhlsex9KccAYWDFwHqbUHajHiawl5qnCvldsHJyHwRtmQUyZaqDSE7nH/YJXJYbaccqwyDzXMcvmacHDEPOYcCprUba/FkUjzQ5IX2LeOpzSTIhC5DHtMfvylllgIA/HKqbFaA+SKc/nLAz0oxLbGr5fefnKrY7ZIPO0Ipkb8hxvYYAme5gpO67tMGP+kWIk1cRsOn4WvBNpdYMLq26Xw/K0DGeoj85rsY+TBU+lzS0pVk+Sh+Hpgvd9ahig35ZDYY71TmWqYVZZA4U5kuNnt9Uwi5FaXsKUDw8OHBvuL0CCPKdwG9dHylB3GCbMTZgR9o0nSJC7IdzCEOvFXc7ClPc+6zr2vLsIMdJbK5FzEKafvTgNQ+8xQD2zwnAQpo895y5MptF4K8adwm8uu3PQ8xqmjwUDMZgdJ+6xGWRtHobpRp00D1j5+VR64PzkiOF6iRMtzAbDl71amFkfGpkDWGENvCx4SNPF0eDENc8AMLWWizaxEcUuMzC6WcjFgvc9+nQgIwvQGDTqDz9+dqD/86Uw/1ulE9aNNcvk1HmM2dyO+V+QmlqYshNQ2JkET4SdKSKE2UqKLniZTQ/un+3eA7v/Ze39f9Bezulz8Kb3TPSYlCQufwp2UphEP2999ftm8ihMnBYpbBv3sHkNhYmhtUtmoM4ptVCYGOU+VymAfvaSwsS45nVfBTDI+ihMLKvyNhttnnA9hYllCkhOh8jG6FMpXt1KIOT9M4PCJNBXmUroOXj0HDxCCCH0TRb0TRb0oGMKQ2EoDIWhMBSGwlAYQmFowaMFjxBCaMGjBY8ueBSGUBgKQ2H+wzDjFCZ5mElhHSRJmLfCJkiSMHOBDZA4W9sfsbhLf0qEEPLDeZQ9kDiSfxF+RQaJI0dd8FGYZGF2MKdIkixHdgXvtntrC4e2VByd6AvW/YGwpChMkZVd6LxS0O8RA4LP89ntxiG3iqMTQ/GSsBuVZWU/DRsCiqwbdkvfk56Jjw67A4ccKo5O9EVDztV1z64kK/Ik/gYKcJRgjepZMwAAAABJRU5ErkJggg==";
    }
  }
  if (!hasMediaSrc) {
    if (type === "image") {
      image.src = path;
      image.classList.remove("hide-slide");
      video.classList.add("hide-slide");
    } else {
      video.src = path;
      video.classList.remove("hide-slide");
      image.classList.add("hide-slide");
      if (index === 0) {
        hasMediaSrc = true;
      }
    }
  }
}

export function resizeSlide(player_id) {
  isResizing = true;
  player_id = player_id.id ? player_id.id : player_id;
  var player = videojs.getPlayers()[player_id];
  var percent = 100;
  var isNavigation = docShadow.getElementsByClassName(
    "vjs-navigation-container-show"
  );
  isNavigation = docShadow.getElementsByClassName("skin-dark")
    ? false
    : isNavigation;
  document.onmouseup = function () {
    stopResizing();
  };
  if (
    window.innerWidth <= 768 &&
    screen.orientation.type.indexOf("landscape") >= 0
  ) {
    let resizer = document.getElementById("resizer");
    if (resizer) {
      resizer.addEventListener("touchend", function () {
        stopResizing();
      });
      resizer.addEventListener("touchleave", function () {
        stopResizing();
      });
      resizer.addEventListener("touchmove", function (e) {
        handleResize(e.touches[0].clientX);
      });
    }
  }

  document.onmousemove = function (e) {
    handleResize(e.clientX);
  };
  function handleResize(clientX) {
    // we don't want to do anything if we aren't resizing.
    if (!isResizing) return;
    if (isNavigation && isNavigation.length > 0) {
      percent = 75;
    }

    var offsetRight =
      player.el().offsetWidth - clientX + player.el().getBoundingClientRect().x;
    percentWidth = Math.round((offsetRight / player.el().offsetWidth) * 100);
    resize();
    player.addClass("no-select");
  }
  function stopResizing() {
    // stop resizing
    isResizing = false;
    player.removeClass("no-select");
  }
  function hasClass(element, className) {
    return (" " + element.className + " ").indexOf(" " + className + " ") > -1;
  }

  function resize() {
    var videos = docShadow.getElementsByClassName("vjs-tech");
    var posters = docShadow.getElementsByClassName("vjs-poster");

    var video = videos && videos[0] ? videos[0] : null;
    var poster = posters && posters[0] ? posters[0] : null;
    var slide = docShadow.getElementById("rm-slides");
    var percentVideo = percent - percentWidth;
    var percentSlide = percentWidth;
    if (percentVideo < 5) {
      percentVideo = 5;
      percentSlide = 95;
    }
    if (percentVideo > 95) {
      percentVideo = 95;
      percentSlide = 5;
    }
    if (hasClass(video, "is-right")) {
      var percentRight = percentVideo;
      percentVideo = percentSlide;
      percentSlide = percentRight;
    }
    video.style.width = percentVideo + "%";
    poster.style.width = percentVideo + "%";
    slide.style.width = percentSlide + "%";

    updateBigPlayButton();
    updateOverlayButtonsPosition();
  }
}

export function changeVideoSlide() {
  var player = document.querySelector(".video-js");
  var video = document.querySelector(".vjs-tech");
  var slide = document.querySelector("#rm-slides");

  if (!video_has_left) {
    slide.classList.remove("is-left");
    slide.classList.add("is-right");
    video.classList.add("is-left");
    video.classList.remove("is-right");
    player.classList.add("is-left");
    player.classList.remove("is-right");
  } else {
    player.classList.remove("is-left");
    player.classList.add("is-right");
    video.classList.remove("is-left");
    video.classList.add("is-right");
    slide.classList.add("is-left");
    slide.classList.remove("is-right");
  }
  video_has_left = !video_has_left;
  updateOverlayButtonsPosition();
  updateBigPlayButton();
}

export function handleShowHideSlides() {
  slides_has_hiden = !slides_has_hiden;
  var showHideBtn = document.getElementById("show-hide-slides-button");
  var bigPlayBtns = document.querySelectorAll(".vjs-big-play-button");
  var video = document.querySelectorAll(".vjs-tech");
  var slide = document.querySelectorAll(".vjs-slide-items");
  var slides = document.querySelector("#vjs-sliders-content");
  if (!slides_has_hiden) {
    if (showHideBtn) {
      showHideBtn.style.transform = "rotate(180deg)";
    }
    if (bigPlayBtns.length) {
      bigPlayBtns[0].classList.add("slides-hidden");
      bigPlayBtns[1].classList.add("slides-hidden");

    }
    video[0].classList.remove("slides-is-hiden");
    video[0].classList.add("slides-is-show");
    slide[0].classList.add("slides-is-show");
    slide[0].classList.remove("slides-is-hiden");
    slides.classList.add("slides-is-hiden");
    slides.classList.remove("slides-is-show");
  } else {
    if (showHideBtn) {
      showHideBtn.style.transform = "rotate(0)";
    }
    if (bigPlayBtns.length) {
      bigPlayBtns[0].classList.remove("slides-hidden");
      bigPlayBtns[1].classList.remove("slides-hidden");

    }
    video[0].classList.add("slides-is-hiden");
    video[0].classList.remove("slides-is-show");
    slide[0].classList.remove("slides-is-show");
    slide[0].classList.add("slides-is-hiden");
    slides.classList.remove("slides-is-hiden");
    slides.classList.add("slides-is-show");
 
  }
  updateBigPlayButton();
  setTimeout(function () {
    updateOverlayButtonsPosition(true);
  }, 500);
}

export function updateBigPlayButton() {
  const mainPlayer = docShadow.querySelector(".video-js");

  var bigButtons = docShadow.querySelectorAll(".vjs-big-play-button");
  if (
    !(
      mainPlayer &&
      bigButtons.length &&
      mainPlayer.classList.contains("vjs-has-started")
    )
  ) {
    return;
  }

  var bigPlayButton = bigButtons[0];
  var bigPauseButton = bigButtons[1];
  const videoEl = docShadow.querySelector(".vjs-tech");

  let i = 0;
  let interval = setInterval(() => {
    if (i === 500) {
      clearInterval(interval);
    }
    i += 10;
    if (videoEl.classList.contains("is-right")) {
      bigPlayButton.style.right =
        "calc(" + window.getComputedStyle(videoEl).width + " / 2 - 60px)";
      bigPlayButton.style.left = "auto";
      bigPauseButton.style.right =
        "calc(" + window.getComputedStyle(videoEl).width + " / 2 - 60px)";
      bigPauseButton.style.left = "auto";
      if(bigButtons.length===4){
        bigButtons[2].style.setProperty('right', "calc(" + getComputedStyle(videoEl).width + " / 2 + 15%)", 'important');
        bigButtons[2].style.setProperty('left', 'auto', 'important');
        bigButtons[3].style.setProperty('right', "calc(" + getComputedStyle(videoEl).width + " / 2 - 15%)", 'important');
        bigButtons[3].style.setProperty('left', 'auto', 'important');
              }
    } else {
      bigPlayButton.style.left =
        "calc(" + window.getComputedStyle(videoEl).width + " / 2 + 10px)";
      bigPlayButton.style.right = "auto";
      bigPauseButton.style.left =
        "calc(" + window.getComputedStyle(videoEl).width + " / 2 + 10px)";
      bigPauseButton.style.right = "auto";
      if(bigButtons.length===4){
        bigButtons[2].style.setProperty('left', "calc(" + getComputedStyle(videoEl).width + " / 2 - 15%)", 'important');
        bigButtons[2].style.setProperty('right', 'auto', 'important');
        bigButtons[3].style.setProperty('left', "calc(" + getComputedStyle(videoEl).width + " / 2 + 15%)", 'important');
        bigButtons[3].style.setProperty('right', 'auto', 'important');   
      }
    }
  }, 10);
}

export function updateSubtitlesPosition() {}

export function updateOverlayButtonsPosition(noInterval) {
  const playerEl = docShadow.querySelector(".video-js");

  if (!playerEl) {
    return;
  }
  const videoEl = docShadow.querySelector(".vjs-tech");
  const overlayBtnsEl = docShadow.getElementById("dark-overlay-buttons");
  const slideEl = docShadow.getElementById("slide-image");
  const slideBtnEl = docShadow.querySelector(
    "#rm-slides .overlay-buttons__container"
  );

  let i = 0;
  let interval = setInterval(() => {
    const isControlBarVisible =
      playerEl.classList.contains("vjs-has-started") &&
      (playerEl.classList.contains("vjs-paused") ||
        playerEl.classList.contains("vjs-user-active"));
    const isSlideVisible = !videoEl.classList.contains("slides-is-show");
    const isVideoRight = videoEl.classList.contains("is-right");
    const isVideoFocused = videoEl.classList.contains("focused");
    if (i === 500 || noInterval) {
      clearInterval(interval);
    }
    i += 10;
    const { offsetWidth, offsetHeight } = videoEl;

    // Bottom
    let bottomStyle = "";
    let isLive = docShadow.getElementById("live_player") ? true : false;

    if (!isVideoFocused) {
      bottomStyle = "calc(";
      bottomStyle += (isControlBarVisible ? "3.5em" : "0.5em") + " + ";
      bottomStyle +=
        (isSlideVisible ? (!isLive ? "20%" : "0px") : "0px") + " + ";
      bottomStyle +=
        offsetWidth / offsetHeight < 16 / 9
          ? "(" + offsetHeight + "px - (" + offsetWidth + "px * 9/16)) / 2)"
          : "0px";
    } else {
      bottomStyle = isControlBarVisible ? "4.5em" : "0px";
    }
    overlayBtnsEl.style.bottom = bottomStyle;

    // Right
    if (!isVideoFocused) {
      let right = !isVideoRight ? playerEl.offsetWidth - offsetWidth : 0;
      overlayBtnsEl.style.right =
        right +
        (offsetWidth / offsetHeight > 16 / 9
          ? (offsetWidth - (offsetHeight * 16) / 9) / 2
          : 0) +
        "px";
    } else {
      overlayBtnsEl.style.right =
        (offsetWidth / offsetHeight > 16 / 9
          ? (offsetWidth - (offsetHeight * 16) / 9) / 2
          : 0) + "px";
    }
    if (slideEl) {
      slideBtnEl.style.width = slideEl.width + "px";
      slideBtnEl.style.height = slideEl.height + "px";
    }
  }, 10);
}

export default {
  toHHMMSS: toHHMMSS,
  updateTime: updateTime,
  changeSlide: changeSlide,
  changeChapter: changeChapter,
  durationToSec: durationToSec,
};
